import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Deletes a note and invalidates relevant caches. */
export function useDeleteNote(options?: { patientId?: string; consultationId?: string }) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await api.delete('/notes/:id', { params: { id } })
      if (!response.success) throw new Error(response.error.message)
    },
    onSuccess: () => {
      if (options?.patientId) {
        queryClient.invalidateQueries({ queryKey: ['patient-timeline', options.patientId] })
        // Deleting a note also removes any files it carried from the patient files box.
        queryClient.invalidateQueries({ queryKey: ['patient-files', options.patientId] })
      }
      if (options?.consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', options.consultationId] })
      }
    },
  })
}
